import { TraitGroups } from './trait-groups';

export default TraitGroups;
